import * as React from "react";
import { Icon } from "sb-resp-ui";
export const renderSportIcon = (sportId, componentPrefix) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}-icon rj-ev-list__${componentPrefix}-icon--sport`, "data-uat": `div-ev-list-${componentPrefix}-icon-sport` },
    React.createElement(Icon, { i: `i-o-sport-${sportId}` }));
//# sourceMappingURL=renderSportIcon.js.map